import domains from '@/publicemaildomains.json';

function isPublic(email) {
  const domain = email.split('@')[1].trim();
  return (domains.includes(domain));
}

export default isPublic;
